import axios from "axios";
import  config  from "../../config";
const apiurl = config.ADMIN_BASE_URL;

// ----------------------------Api service for get posts------------------------
export const getPosts = async (status, page) => {
  console.log("status", status, "page", page);
  const token = localStorage.getItem("cookies");
  try {
    // If the status is 3, don't call the posts-by-status API
    const url =
      status == 3 ? `${apiurl}/posts` : `${apiurl}/posts/posts-by-status`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: status !== 3 ? { status: status, page: page } : { page: page }, // Include page only for other statuses
    });

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message || "Failed to fetch posts.");
    } else if (err.request) {
      throw new Error("No response from server. Please check your connection.");
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

//---------------------------------------------api to block post , unblock post and review post based on status-------------------------------
export const actionOnPost = async (postId, status) => {
  console.log("postId", postId, "status", status);
  const token = localStorage.getItem("cookies");
  try {
    const response = await axios.post(
      `${apiurl}/posts/${postId}/status`,
      { status },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response from actionOnPost:", response.data);
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message || "Failed to perform action.");
    } else if (err.request) {
      throw new Error("No response from server. Please check your connection.");
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
